import { getOthGebruiker } from '@/api/generated/digiVAPI';
import { createQuery } from '@/utils/tanstack-query/createQuery';

export const useGebruiker = createQuery({
  key: ['gebruiker'],
  queryFn: () => getOthGebruiker(),
  defaultOptions: {
    // The gebruikers are very unlikely to change, so we can cache them for a long time
    staleTime: Infinity,
  },
});

export const useGebruikerId = (
  id: string,
  options: { enabled?: boolean } = {}
) => {
  return useGebruiker('', {
    select: (gebruikers) => {
      return gebruikers.find((gebruiker) => gebruiker.ID === id) ?? null;
    },
    ...options,
  });
};
